import { Link } from 'react-router-dom'
import Image from '../Images/Group.svg'
import Image1 from '../Images/Group_1.svg'
import Image2 from '../Images/Group_2.svg'
import Image3 from '../Images/Group_3.svg'
import Image4 from '../Images/Group_4.svg'
import Image5 from '../Images/Group_5.svg'

function PosterOne(){
  return(
    <div className="one d-flex justify-content-around align-items-center h-100">
    <div className="left">
      <img src={Image} className='image' />
      <img src={Image1} className='image-one' />
      <img src={Image2} className='image-two' />
      <img src={Image3} className='image-three' />
      <img src={Image4} className='image-four' />
      <img src={Image5} className='image-five' />
    </div>
    <div className='center d-flex flex-column align-items-center'>
      <p>خصم لحد</p>
      <span>70%</span>
    </div>
    <div className='right'>
      <p>ماتفوتش العروض</p>
      <Link>تسوقو الان </Link>
    </div>
  </div>
  )
}
export default PosterOne;